import {
	pickUpCall,
	pickUpEmail,
	pickUpGeneric,
	pickUpWebchat,
	pickUpWhatsApp,
	pickUpVoicemail,
} from "@/repository/queryFns";
import { addBreadcrumb, captureError } from "@/common/helpers/sentryHelper";
import { useMessage } from "@/common/messages";
import { AgentState, useAgentStore } from "@/common/stores/persistingStores/agentPermissions";
import { InteractionType } from "@/common/types";
import { useIntl } from "react-intl";
import { checkIsTeamsPresenceDnd } from "./checkIsTeamsPresenceDnd";

export const useInteractionPickUp = () => {
	const { show: showMessage } = useMessage();
	const availability = useAgentStore((state: AgentState) => state.availability);
	const intl = useIntl();

	const handlePickUpInteraction = async (interactionId: string, pickUpFn: (id: string) => Promise<boolean>) => {
		if (await checkIsTeamsPresenceDnd(availability)) {
			showMessage("workspace", {
				intent: "error",
				text: intl.formatMessage({
					id: "ErrorMessage.Pickup.PickupDND",
				}),
			});

			return;
		}

		pickUpFn(interactionId)
			.then((isPickedUp) => {
				if (!isPickedUp) {
					showMessage("workspace", {
						intent: "error",
						text: intl.formatMessage({
							id: "ErrorMessage.Pickup.InteractionUnavailable",
						}),
					});
				}
			})
			.catch((err: Error) => {
				captureError(err, "Error on pickup");
				showMessage("workspace", {
					intent: "error",
					text: `${intl.formatMessage({ id: "Common.Error" })} ${err}`,
				});
			});
	};

	const pickUpInteraction = (_: any, interaction: { id: string; type: InteractionType }) => {
		addBreadcrumb("ui_interaction", "picking up interaction", interaction);
		switch (interaction.type) {
			case InteractionType.Call:
				handlePickUpInteraction(interaction.id, pickUpCall);
				break;
			case InteractionType.Generic:
				handlePickUpInteraction(interaction.id, pickUpGeneric);
				break;
			case InteractionType.Voicemail:
				handlePickUpInteraction(interaction.id, pickUpVoicemail);
				break;
			case InteractionType.Email:
				handlePickUpInteraction(interaction.id, pickUpEmail);
				break;
			case InteractionType.WhatsApp:
				handlePickUpInteraction(interaction.id, pickUpWhatsApp);
				break;
			case InteractionType.Webchat:
				handlePickUpInteraction(interaction.id, pickUpWebchat);
				break;
		}
	};

	return pickUpInteraction;
};
